import { render, staticRenderFns } from "./couponcreate_activity_step.vue?vue&type=template&id=1120215a&scoped=true"
import script from "./couponcreate_activity_step.vue?vue&type=script&lang=js"
export * from "./couponcreate_activity_step.vue?vue&type=script&lang=js"
import style0 from "./couponcreate_activity_step.vue?vue&type=style&index=0&id=1120215a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120215a",
  null
  
)

export default component.exports